import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminStudents,
  createAdminStudent,
  updateAdminStudent,
  deleteAdminStudent,
} from "../../api/admin/students.api";

/* ================= FETCH ================= */
export const fetchStudents = createAsyncThunk(
  "admin/students/fetch",
  async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
    const res = await getAdminStudents({ page, limit, search });

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* ================= CREATE ================= */

export const addStudent = createAsyncThunk(
  "students/addStudent",
  async (payload, { rejectWithValue }) => {

    console.log("📡 ADD STUDENT API CALL PAYLOAD:", payload);

    const res = await createAdminStudent(payload);

    console.log("📥 ADD STUDENT API RESPONSE:", res);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* ================= UPDATE ================= */
export const updateStudent = createAsyncThunk(
  "admin/students/update",
  async ({ id, studentData }, { rejectWithValue }) => {
    const res = await updateAdminStudent(id, studentData);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* ================= DELETE ================= */
export const deleteStudent = createAsyncThunk(
  "admin/students/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteAdminStudent(id);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return { id };
  }
);
